<template>
	<div>
		<div class="maskbox" @click="closePopupBox"></div>
		<div class="ui-dialog">
			<div class="ui-dialog-title">《体积和重量说明》</div>
			<div class="ui-dialog-content">
				<div class="ui-dialog-content">
					<ul class="ui-article ui-article-scroll">
						<li>体积重量是一种反映包裹密度的计算方式。低密度的包裹，比较其实际重量，占用的空间通常较大。计算出来的体积重量，会与其实际重量比较，取较重者为计费重量，用以计算运费。</li>
						<li>根据市场惯例，体积重量(kg)的计算方法为:长度(cm) x 宽度(cm) x 高度(cm) ÷ 6,000(计算方法都是按地区及市场惯例决定, 当中可能各有差异。)</li>
					</ul>
				</div>
			</div>
			<div class="ui-dialog-bt"><input type="button" @click="closePopupBox" class="ui-btn btn-submit" value="知道了"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "VolumeWeightDialog",
		methods: {
			closePopupBox: function () {
				this.$emit('showVolumeAndWeightDesc', false)
			}
		}
	}
</script>

<style scoped>
	.maskbox {
		position: fixed;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background: rgba(0, 0, 0, 0.6);
		z-index: 10000;
	}
	div {
		font-size: 100%;
		font-weight: normal;
	}
	.ui-dialog {
		position: fixed;
		top:50%;
		left:50%;
		transform:translateX(-50%) translateY(-50%);
		height: auto;
		overflow: hidden;
		background: #fff;
		z-index: 10001;
		border-radius: .3em;
		-webkit-border-radius: .3em;
		width: 96.4%;
		margin-left: auto;
		margin-right: auto;
	}
	.ui-dialog-title {
		padding: 10px 0;
		text-align: center;
		border-bottom: #ddd 1px solid;
		color: #ed2210;
		font-weight: bold;
	}
	.ui-dialog-content {
		padding: 10px;
		overflow-y: auto;
		box-sizing: border-box;
	}
	.ui-article-scroll {
		max-height: 300px;
		overflow-y: auto;
	}
	ul {
		list-style: none;
	}
	ul, li {
		list-style: none;
	}
	.ui-article li {
		margin: 7px 0;
		list-style: disc;
		margin-left: 20px;
	}
	.ui-dialog-bt {
		padding: 10px;
		border-top: #ddd 1px solid;
	}
	input[type="button"] {
		-webkit-appearance: none;
	}
	.btn-submit {
		background-color: #ed2210;
		color: #fff;
		padding: .8em 0;
		border: 0;
		width: 100%;
	}
	.ui-btn {
		display: inline-block;
		vertical-align: middle;
		width: 100%;
		text-align: center;
		font-size: 1em;
		cursor: pointer;
		font-size: 1.143em;
		border-radius: .3em;
		-moz-border-radius: .3em;
		-webkit-border-radius: .3em;
	}

</style>



// WEBPACK FOOTER //
// src/pages/payFee/volume-weight-dialog.vue